import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const languageStore = createSlice({
  name: "language",
  initialState: {
    "lang":"it"
  },
  reducers: {
    updateLanguage(_state, action: PayloadAction<any>) {
        _state.lang = action.payload;
    },
  },
});

export default languageStore;

export const {
    updateLanguage
} = languageStore.actions;
